var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoanLossReserveToTotalLoansAndLeases = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9434 22.962L16.0684 18.462C15.9514 18.1815 15.6784 18 15.3754 18H11.6254C11.3224 18 11.0494 18.1815 10.9324 18.462L9.05736 22.962C8.96136 23.193 8.98686 23.457 9.12636 23.6655C9.26586 23.8755 9.49986 24 9.75036 24H17.2504C17.5009 24 17.7349 23.8755 17.8744 23.6655C18.0139 23.457 18.0394 23.193 17.9434 22.962Z",
    fill: "#00D2A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.943 22.962L22.0725 18.462C21.9555 18.183 21.6825 18 21.3795 18H17.619C17.4015 18 17.202 18.096 17.0625 18.252L18.864 22.578C19.056 23.0415 19.0275 23.5545 18.8145 24H23.25C23.5005 24 23.7345 23.8755 23.874 23.6655C24.0135 23.4585 24.039 23.193 23.943 22.962Z",
    fill: "#00D2A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9434 15.962L19.0684 11.462C18.9514 11.1815 18.6784 11 18.3754 11H14.6254C14.3224 11 14.0494 11.1815 13.9324 11.462L12.0574 15.962C11.9614 16.193 11.9869 16.457 12.1264 16.6655C12.2659 16.874 12.4999 17 12.7504 17H20.2504C20.5009 17 20.7349 16.8755 20.8744 16.6655C21.0139 16.457 21.0394 16.1945 20.9434 15.962Z",
    fill: "#00D2A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99139 4.5H13.0074L14.7369 3.1155C15.3264 2.646 15.5454 1.8825 15.2964 1.17C15.0489 0.4605 14.4009 0 13.6494 0H4.34939C3.59789 0 2.94989 0.4605 2.70089 1.1715C2.45189 1.8825 2.67089 2.646 3.26039 3.1155L4.99139 4.5Z",
    fill: "#6C7DE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6725 22.3884L9.5475 17.8869C9.753 17.3934 10.128 17.0214 10.5795 16.7829C10.467 16.3239 10.485 15.8379 10.6725 15.3894L12.5475 10.8879C12.8985 10.0464 13.713 9.50341 14.625 9.50341H15.75C15.0015 8.16991 14.115 6.95491 13.1445 6.00391H4.8555C2.124 8.68291 0 13.3854 0 17.2509C0 20.6109 1.7775 24.0009 5.7495 24.0009H7.6275C7.4445 23.4819 7.455 22.9074 7.6725 22.3884Z",
    fill: "#6C7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoanLossReserveToTotalLoansAndLeases);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loan_loss_reserve_to_total_loans_and_leases.4e7ec07c0d36fd606950da67619dc664.svg";